// extracted by mini-css-extract-plugin
export default {"container":"osXPhoXSGqs63lJu7fjB"};